import React from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { safeIdString } from "utils/utils";
import { useCompanyTimezone } from "hooks/useTimezone";
import { Instant } from "@js-joda/core";
import { DataDisplayType, ValueChangeIndicatorProps } from "./ValueChangeIndicatorTypes";
import { getMonthYearComparison } from "./ValueChangeIndicatorUtils";
import ValueContainer from "./ValueContainer";
import { formatNumber, getTextColor } from "../charts/utils";
import CurrentValueTooltip from "./CurrentValueTooltip";

const LastValueForMonthYearComparison = (
  props: ValueChangeIndicatorProps & {
    dataRange?: DatasetDataInfoResponse[];
    refTime: Instant;
    diffDecimalPlaces?: number;
    setDialog: (isVisible: boolean) => void;
  }
) => {
  const companyTz = useCompanyTimezone();
  if (
    Array.isArray(props.dataRange) &&
    props.dataRange.length === 1 &&
    props.dataDisplayType === DataDisplayType.MONTH_YEAR_COMPARISON
  ) {
    const dataset = props.dataRange[0];

    const { curr, currValueKey } = getMonthYearComparison(dataset.data, companyTz, props.refTime);
    const value = curr !== null ? curr : 0;
    const valueKey = currValueKey;

    const safeId = safeIdString(dataset.identifier);
    const tooltipId = `last-value-${safeId}-tooltip`;
    return (
      <ValueContainer
        id={tooltipId}
        value={formatNumber(value, props.decimalPlaces, props.convertToAbsoluteValues)}
        unit={!props.hideUnit ? dataset.unit : undefined}
        highlight={props.highlightValue}
        color={getTextColor(props.theme)}
        onDoubleClick={() => props.setDialog(true)}
      >
        <CurrentValueTooltip
          id={tooltipId}
          value={value}
          valueKey={valueKey}
          unit={dataset.unit}
          diffDecimalPlaces={props.diffDecimalPlaces}
          tz={companyTz}
        />
      </ValueContainer>
    );
  }
  return null;
};

export default LastValueForMonthYearComparison;
